export function audioNotify() {
  const audio = new Audio('/media/notify.wav')
  audio.play().then()
}

export function audioDing() {
  const audio = new Audio('/media/ding.wav')
  audio.play().then()
}
